const SET_INGREDIENTS = (state, data) => {
  state.ingredients = data
}

const SET_INGREDIENT = (state, data) => {
  state.ingredient = data
}

const PUSH = (state, data) => {
  state.ingredients.push(data)
}

const UPDATE = (state, data) => {
  const idx = state.ingredients.findIndex(x => x.id === data.id)

  if (idx !== -1) {
    state.ingredients[idx] = data
  }
}

const REMOVE = (state, id) => {
  const idx = state.ingredients.findIndex(x => x.id === id)

  if (idx !== -1) {
    state.ingredients.splice(idx, 1)
  }
}

export default {
  PUSH,
  UPDATE,
  REMOVE,
  SET_INGREDIENT,
  SET_INGREDIENTS
}
